import AppIcon from "@components/AppIcon";
import { Fragment, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import MiniSidebarItem from "./components/MiniSidebarItem";

export default function MiniSidebar() {
  /** */

  // SiderBar Expanded
  const [isExpanded, setIsExpanded] = useState(false);

  // Callbacks
  const _handleToggleSidebar = useCallback(() => setIsExpanded((prev) => !prev), []);

  // Sidebar Items
  const _SIDEBAR = [
    // {
    //   title: "T.DASHBOARD",
    //   path: "/dashboard",
    //   icon: "fa-dashboard",
    // },
    { title: "T.USERS", icon: "fa-users", path: "/users" },
    // { title: "T.SETTINGS", icon: "fa-cog", path: "/settings" },
  ];

  return (
    <div className={`hidden md:flex sticky top-0 h-screen flex-shrink-0 border-r flex-col bg-card ${isExpanded ? "w-64" : "w-20"}`}>
      <div className={`py-2 flex items-center justify-${isExpanded ? "end" : "center"} px-4 border-b`}>
        <button onClick={_handleToggleSidebar} className="text-fg hover:text-primary h-12">
          <AppIcon code="fa-sidebar" className="w-6" />
        </button>
      </div>
      {_SIDEBAR.map(({ icon, media, active, path, notification, onClick, title }, _index) => (
        <Fragment key={_index}>
          {path ? (
            <Link to={path}>
              <MiniSidebarItem key={_index} icon={icon} media={media} active={active} notification={notification} title={title} isExpanded={isExpanded} />
            </Link>
          ) : (
            <MiniSidebarItem
              key={_index}
              icon={icon}
              media={media}
              active={active}
              notification={notification}
              onClick={onClick}
              title={title}
              isExpanded={isExpanded}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
}
